<i
    [attr.data-testid]="uid"
    class="country-flag famfamfam-flags {{ getCountryCode() }}"
    aria-hidden="true"
    mazarsTooltip="{{ getCountryName() }}"
    [escape]="false"
></i>
